import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-bootstrap/Modal";
import TimeAgo from "react-timeago";
import { FilterActions, MerchantActions } from "../../../actions";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import "./notification.css";
import InfiniteScroll from "react-infinite-scroll-component";
import {  } from "react-router-dom";
import Loader from "react-loader-spinner";
import { Spinner } from "react-bootstrap";
class Notifications extends Component {
  id = window.localStorage.getItem("_id");
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      invoicesList: [],
      funderReceivedAmount: 0,
      unReadNotifications: [],
      unReadNotificationsId: [],
      sortedData: [],
      notificationData: [],
      hasMore: true,
      isMarkReadLoader: false,
    };
  }

  componentDidMount() {
    if (window.localStorage.getItem("_id")) {
      this.id = window.localStorage.getItem("_id");
    } else {
      window.location.reload();
    }
    if (this.props.data) {
      const filteredResult = this.props.data.filter((item) => {
        return item.flag === 0;
      });
      const unReadIds = filteredResult.map((item) => {
        return item.id;
      });
      this.setState({
        unReadNotifications: filteredResult,
        unReadNotificationsId: unReadIds,
      });
    }
    this.fetchMoreData(true);
    this.props
      .getGenericsStoreProcedure({
        storeProcedureName: "unReadNotificationCount",
        merchantId: this.id,
      })
      .then(() => {});
  }

  updateNotification = (id) => {
    console.log("updateNotification");
    const params = {
      merchantId: this.id,
      flag: 1,
      id: id,
    };
    this.props.updateNotifications(params).then(() => {
      // this.props.getNotifications(this.id).then(() => {
      // if (this.props.getAllNotificationsData) {
      // const filteredResult = this.props.getAllNotificationsData.filter((item) => {
      //     return item.flag === 0
      // })
      // this.setState({
      //     unReadNotifications: filteredResult,
      // })
      this.props
        .getGenericsStoreProcedure({
          storeProcedureName: "unReadNotificationCount",
          merchantId: this.id,
        })
        .then(() => {});
      // this.fetchMoreData(true);
      // }
    });
  };

markAsRead = () => {
  this.setState({ isMarkReadLoader: true });

  this.props.getNotifications(this.id).then(() => {
    setTimeout(() => {
      const allNotifications = this.props.getAllNotificationsData;

      if (allNotifications && allNotifications.length > 0) {
        const filteredResult = allNotifications.filter(item => item.flag === 0);

        if (filteredResult.length > 0) {
          const idArray = filteredResult.map(item => item.id);

          const params = {
            merchantId: this.id,
            flag: 1,
            ids: idArray,
            id: "",
          };


          this.props.updateNotifications(params).then(() => {
            this.props.getNotifications(this.id).then(() => {
              setTimeout(() => {
                const updatedNotifications = this.props.getAllNotificationsData || [];
                const unread = updatedNotifications.filter(item => item.flag === 0);

                this.props.getGenericsStoreProcedure({
                  storeProcedureName: "unReadNotificationCount",
                  merchantId: this.id,
                });

                this.fetchMoreData(true);
                this.setState({ isMarkReadLoader: false });
              }, 200); // delay again to ensure props are updated
            });
          });
        } else {
          this.setState({ isMarkReadLoader: false });
        }
      } else {
        this.setState({ isMarkReadLoader: false });
      }
    }, 200); // 200ms delay to wait for props update
  });
};



  fetchMoreData = (initial = false) => {
    if (
      !initial &&
      this.state.notificationData.length >= this.props.totalElement
    ) {
      this.setState({ hasMore: false });
      return;
    }
    let page = initial ? 0 : this.state.notificationData.length / 10;
    let param = {
      merchantId: this.id,
      size: 10,
      page: page,
    };
    this.props.getNotificationPagination(param).then(() => {
     setTimeout(() => {
       if (this.props.notificationList) {
        initial
          ? this.setState({
              notificationData: [],
            })
          : "";
        this.setState({
          notificationData: this.state.notificationData.concat(
            this.props.notificationList
          ),
        });
      }
     }, 1000);
    });
  };
  handelNotificationClick = (item) => {
    console.log("item", item);
    if (item?.idType) {
      if (!(item?.objId && item?.buyerPlatformId)) {
        console.log("No Obj and Bu");
        this.handelRedirect(item?.idType);
      } else {
        this.props
          .setNotificationData({
            type: item?.idType,
            buyerPlatformId: item?.buyerPlatformId,
            buyerPlatformType: item?.buyerPlatform?.typeDescription ?? "",
            objectId: item?.objId,
            onjectData: item?.objectItem ?? "",
          })
          .then(() => this.handelRedirect(item?.idType, true));
      }
    }
  };
  handelRedirect = (type, nonDataRedirect = false) => {
    switch (type) {
      case "Request":
        this.props.navigate("/user/requests");
        break;
      case "Pending":
        this.props.navigate("/user/pendings");
        break;
      case "Reserve":
        if (!nonDataRedirect) {
          this.props.setNotificationData({
            type: type,
            buyerPlatformId: "",
            buyerPlatformType: "",
            objectId: 123,
            onjectData: "",
          });
        }
        this.props.navigate("/user");
        break;
      default:
        console.log("type", type);
        break;
    }
  };

  render() {
    const { notificationData } = this.state;
    return (
      <Modal
        show={this.props.openModal}
        onHide={() => this.props.closeModal()}
        className="ModalDemo"
        dialogClassName="mdlDir"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header className="border-0 alignClose" closeButton>
          {this.props.genericProcedureData?.[0]?.unreadCount > 0
            ? "Notifications(" +
              this.props.genericProcedureData?.[0]?.unreadCount +
              ")"
            : "Notifications"}

          {this.state.isMarkReadLoader ? (
            <Spinner size="sm" className="loaderSize" animation="border" style={{marginLeft : "15px"}} />
          ) : this.props.genericProcedureData?.[0]?.unreadCount > 0 &&
            !this.state.isMarkReadLoader ? (
            <a className="markRead cursor" onClick={this.markAsRead} style={{marginLeft : "15px"}}>
              Mark as read
            </a>
          ) : (
            <></>
          )}
        </Modal.Header>
        <Modal.Body className="pb-100" id="scrollableDiv">
          <InfiniteScroll
            dataLength={notificationData.length}
            next={() => this.fetchMoreData()}
            className="pl-3 pr-3 notifiBox"
            hasMore={this.state.hasMore}
            scrollableTarget="scrollableDiv"
          >
            <Accordion className="notification-wrap cursor">
              {notificationData
                ? notificationData.map((item, index) => (
                    <Card
                      key={item?.id ?? index}
                      onClick={() => this.updateNotification(item?.id)}
                    >
                      <Accordion.Toggle as={Card.Header} eventKey={index + 1}>
                        <div className="notification-item">
                          <h5>
                            <TimeAgo date={item?.creationTimestamp} />{" "}
                            <i className="arrow-down"></i>
                          </h5>
                          <p>
                            {item?.flag == 0 ? (
                              <b> {item?.title} </b>
                            ) : (
                              item?.title
                            )}
                          </p>
                        </div>
                      </Accordion.Toggle>

                      <Accordion.Collapse eventKey={index + 1}>
                        <Card.Body
                          onClick={() => this.handelNotificationClick(item)}
                        >
                          <p>{item?.message}</p>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  ))
                : ""}
            </Accordion>
          </InfiniteScroll>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = ({ MerchantListReducer }) => {
  return {
    updateNotificationsData: MerchantListReducer.updateNotificationsData,
    getAllNotificationsData: MerchantListReducer.getNotifications,
    notificationList: MerchantListReducer.notificationList,
    totalElement: MerchantListReducer.totalElement,
    genericProcedureData: MerchantListReducer.genericProcedureNotificationCount,
  };
};

const mapDispatchToProps = {
  updateNotifications: MerchantActions.updateNotifications,
  getNotifications: MerchantActions.getNotifications,
  getNotificationPagination: MerchantActions.getNotificationPagination,
  setNotificationData: FilterActions.setNotificationData,
  getGenericsStoreProcedure: MerchantActions.getGenericsStoreProcedure,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)((Notifications));
